import { render, staticRenderFns } from "./ImgCode.vue?vue&type=template&id=0dbac864&scoped=true"
import script from "./ImgCode.vue?vue&type=script&lang=js"
export * from "./ImgCode.vue?vue&type=script&lang=js"
import style0 from "./ImgCode.vue?vue&type=style&index=0&id=0dbac864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbac864",
  null
  
)

export default component.exports